export function parseDeadline(hour: string) {
  const [hours, minutes, seconds] = hour.split(":");

  if (hours && minutes && seconds) {
    const date = new Date();
    date.setHours(Number(hours), Number(minutes), 0, 0);
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleTimeString#using_options
    return date.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
    });
  }
  return null;
}
